export default __webpack_public_path__ + "767dcd94b0798d0eb6d7c9ab7a1a5c40.png";